import { createApi } from '@reduxjs/toolkit/query/react';
import { createAuthenticatedBaseQuery, API_BASE_URLS } from '../shared';

/**
 * Labor Management API - Base definition
 *
 * Endpoints are split by domain aggregate and injected using injectEndpoints.
 *
 * @see endpoints/staffingEndpoints.ts   - Staffing rules CRUD
 * @see endpoints/budgetSummaryEndpoints.ts - Budget summary (historical comparison)
 */
export const laborManagementApi = createApi({
  reducerPath: 'laborManagementApi',
  baseQuery: createAuthenticatedBaseQuery(API_BASE_URLS.laborManagement),
  tagTypes: [
    'StaffingRule',
    'BudgetSummary',
  ],
  endpoints: () => ({}),
});
